    /**
     * Subtle pointer-based wiggle on .button elements
     */
    function initButtonHoverWiggle() {
        // Skip on non-hover devices
        if (!(window.matchMedia && window.matchMedia('(hover:hover)').matches)) return;

        const buttons = Array.from(document.querySelectorAll('.button:not(.no-wiggle)'));
        if (!buttons.length) return;

        const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

        buttons.forEach(btn => {
            if (btn.dataset.wiggleInitialized === 'true') return;
            btn.dataset.wiggleInitialized = 'true';

            let rafId = null;
            let targetTx = 0, targetTy = 0, targetR = 0;

            const maxTranslate = 6;   // px
            const maxRotate = 6;      // deg
            const ease = 0.18;        // smoothing factor

            const render = () => {
                // Smoothly approach target
                const style = btn.style;
                if (!btn._wiggle) btn._wiggle = { tx: 0, ty: 0, r: 0 };
                const s = btn._wiggle;
                s.tx += (targetTx - s.tx) * ease;
                s.ty += (targetTy - s.ty) * ease;
                s.r  += (targetR  - s.r ) * ease;
                style.transform = `translate(${s.tx.toFixed(2)}px, ${s.ty.toFixed(2)}px) rotate(${s.r.toFixed(2)}deg)`;
                rafId = requestAnimationFrame(render);
            };

            const onMove = (e) => {
                const rect = btn.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const y = e.clientY - rect.top;
                const nx = clamp((x / rect.width) * 2 - 1, -1, 1);   // -1..1 left→right
                const ny = clamp((y / rect.height) * 2 - 1, -1, 1);  // -1..1 top→bottom
                targetTx = nx * maxTranslate;
                targetTy = ny * maxTranslate;
                // rotate a bit as if pivoting around center
                targetR = (nx * -maxRotate * 0.6) + (ny * maxRotate * 0.4);
            };

            const onEnter = () => {
                if (rafId == null) rafId = requestAnimationFrame(render);
                btn.addEventListener('mousemove', onMove);
            };

            const onLeave = () => {
                btn.removeEventListener('mousemove', onMove);
                targetTx = 0; targetTy = 0; targetR = 0;
                // allow animation to ease back then stop
                setTimeout(() => {
                    if (!btn.matches(':hover')) {
                        if (rafId) cancelAnimationFrame(rafId);
                        rafId = null;
                        btn.style.transform = '';
                        btn._wiggle = { tx: 0, ty: 0, r: 0 };
                    }
                }, 180);
            };

            btn.addEventListener('mouseenter', onEnter);
            btn.addEventListener('mouseleave', onLeave);
        });
    }
